import { useCallback } from 'react'
import { connectSockets } from 'services/socket/socket'

export const useSocketConnection = () => {
  const enableSocketConnection = useCallback(() => {
    connectSockets()
  }, [])

  return enableSocketConnection
}
